import React from 'react';

const Header = () => {
  return (
    <div className="header">
      <h1>🍺 Beer Scraper</h1>
      <p>A real-time list of beers on tap at LA's best craft beer taplists</p>
    </div>
  );
};

export default Header;